
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#F07300"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.98 19.136l-1.496-5.209-1.197-4.171c-.097-.339-.267-.702-.908-.738-2.522-.172-4.612.927-6.7 2.026-2.09 1.1-4.179 2.2-6.701 2.027-.398-.047-.654.149-.557.488l.886 3.093c.6 2.096 1.2 4.192 1.806 6.287.145.501.51.691.909.738 2.522.172 4.61-.927 6.7-2.027s4.178-2.198 6.7-2.026c.399.046.654-.15.557-.488zm-3.96-8.938l.371 1.293.372 1.295c-1.06.033-1.997.235-2.99.586l-.378-1.32-.364-1.268c.992-.35 1.928-.553 2.99-.586zm-5.175 4.62c.956-.527 1.91-1.032 2.928-1.446l.844 2.94c-1.017.415-1.973.92-2.928 1.446l-.563-1.96-.281-.98zm-2.923 1.466c-1.035.386-2.025.614-3.14.645l.25.87.594 2.07c1.115-.03 2.105-.258 3.14-.645l-.844-2.94zm0 0l-.742-2.588c1.012-.427 1.966-.938 2.922-1.466l.397 1.382.346 1.205c-.956.528-1.91 1.04-2.923 1.467zm1.598 5.567l-.754-2.626c1.005-.424 1.953-.931 2.902-1.456l.754 2.627c-.95.524-1.897 1.03-2.902 1.455zm5.869-2.92l-.754-2.626c.986-.347 1.918-.547 2.972-.58l.754 2.627c-1.054.032-1.986.232-2.973.58zM9.636 11.61c.45-.108.909.15 1.023.575l4.585 15.824c.114.426-.159.859-.61.966a.893.893 0 01-.207.025c-.377 0-.72-.24-.816-.6L9.026 12.576c-.114-.426.159-.858.61-.966z","fill":"#fff"}})])
          )
        }
      }
    